// @flow

/**
 * Module dependencies.
 */

import { colors, media, shadows, units } from 'client/styles';
import { ifProp } from 'styled-tools';
import { position, size } from 'polished';
import styled from 'styled-components';

/**
 * `Panel` component.
 */

export default styled.div`
  background-color: ${colors.white};
  border-radius: 3px;
  box-shadow: ${shadows.medium};
  min-height: 200px;
  padding: ${units(6)} ${units(3)} ${units(5)};
  position: relative;
  text-align: center;
  max-width: ${ifProp('fluid', '420px', '100%')};
  margin: 0 auto;

  &:before {
    ${position('absolute', '0', '0', null, '0')};
    ${size(units(1), '100%')};

    background-color: ${colors.brandPrimary};
    border-radius: ${ifProp('fluid', '3px 3px 0 0', 0)};
    content: '';
    display: block;
    z-index: 10;

    ${media.min.lg`
      border-radius: 3px 3px 0 0;
    `}

    ${({ themeColor }) => `
      background-color: ${themeColor};
    `};
  }

  ${media.min.xs`
    padding-left: ${units(6)};
    padding-right: ${units(6)};
  `};

  ${media.min.lg`
    margin-top: 26px;
    max-width: 420px;
  `}
`;



// WEBPACK FOOTER //
// ../src/client/components/forms/components/panel.js